/* eslint-disable */
// Based on https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure

class Video {
    constructor() {
        this.instances = document.querySelectorAll('[data-progressive-enhancement="off"][data-progressive-enhancement-type="video"]');

        this.videosStatus = null;
    }

    init(helpers) {
        const self = this;

        this.helpers = helpers;

        self.enhanceAll(self);
    }

    enhance(instance, self) {
        let figcaptionFragmentId,
            link,
            loadButton,
            loadButtonBr,
            loadButtonVisuallyHiddenSpan,
            loadButtonSpan,
            thumbnail,
            videoContent,
            videoContentPlayer;

        figcaptionFragmentId = instance.querySelector('.video__title[id]').id;

        videoContent = instance.querySelector('.video__content');

        if(!videoContent) {
            return;
        }
        
        link = videoContent.querySelector('.video__content__link');

        if(!link) {
            return;
        }

        thumbnail = instance.querySelector('img.js-video-thumbnail');

        if(thumbnail) {
            thumbnail = thumbnail.cloneNode(true);
        }

        link.parentElement.removeChild(link);

        if(!thumbnail) {
            self.loadVideo(instance);
        } else {
            let iframe;

            loadButton = self.helpers.createButton('');

            if(figcaptionFragmentId) {
                loadButton.setAttribute('aria-describedby', figcaptionFragmentId);
            }

            videoContentPlayer = videoContent.querySelector('.video__content__player');

            videoContent.insertBefore(loadButton, videoContentPlayer);

            loadButton.className = 'video__content__load-button';

            loadButton.appendChild(thumbnail);

            loadButtonBr = document.createElement('br');

            loadButtonBr.setAttribute('aria-hidden', 'true');

            loadButton.appendChild(loadButtonBr);

            loadButtonVisuallyHiddenSpan = document.createElement('span');

            loadButtonVisuallyHiddenSpan.classList.add('visually-hidden');

            loadButtonVisuallyHiddenSpan.appendChild(document.createTextNode(wp.i18n.sprintf(i18n.Video.loadVideo, '') + ' ' + i18n.Video.and + ' '));
            
            loadButtonSpan = document.createElement('span');

            loadButton.appendChild(loadButtonVisuallyHiddenSpan);

            loadButton.appendChild(loadButtonSpan);

            loadButtonSpan.appendChild(document.createTextNode(i18n.Video.playVideo));

            instance.dataset.videoStatus = 'awaiting-click';
            
            loadButton.addEventListener('click', function(e) {
                self.loadAndPlayVideo(e, self);
            });
        }
 
        instance.dataset.progressiveEnhancement = 'on';
    }

    enhanceAll(self) {
        if (self.videosStatus !== 'on') {
            for (let instance of self.instances) {
                instance = self.enhance(instance, self);
            }

            self.videosStatus = true;
        }

        if(self.videosStatus) {
            if(document.documentElement.dataset.progressiveEnhancements) {
                document.documentElement.dataset.progressiveEnhancements += ' video';
            } else {
                document.documentElement.dataset.progressiveEnhancements = 'video';
            } 
        }
    }

    loadVideo(instance) {
        let iframe;
            
        iframe = instance.querySelector('iframe.js-video-player');

        if(!iframe) {
            return;
        }

        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');
        iframe.hidden = false;

        instance.dataset.videoStatus = 'loaded';
    }

    loadAndPlayVideo(e, self) {
        if('BUTTON' !== e.currentTarget.tagName) {
            return;
        }

        let button = e.currentTarget,
            br = button.querySelector('br'),
            iframe,
            iframeDataSrc,
            instance = button.closest('[data-progressive-enhancement][data-progressive-enhancement-type="video"]'),
            thumbnail = button.querySelector('img');
        
        iframe = instance.querySelector('iframe.js-video-player');

        iframeDataSrc = new URL(iframe.dataset.src);

        iframeDataSrc.searchParams.set('rel', '0');
        iframeDataSrc.searchParams.set('autoplay', '1');
        iframeDataSrc.searchParams.set('modestbranding', '1');

        iframe.dataset.src = iframeDataSrc;

        self.loadVideo(instance);
        button.disabled = true;
        button.removeChild(thumbnail);
        button.removeChild(br);
    }
}// end Class

// Singleton
export default Video;